// extracted by mini-css-extract-plugin
export var footer = "_nt-0";
export var inherit = "_nt-1";
export var input = "_nt-2";
export var modalContent = "_nt-3";
export var quillEditor = "_nt-4";
export var subtitle = "_nt-5";